module.exports = __webpack_public_path__ + "static/media/tree_3.7d327393.jpg";